const getCookie = name => {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + '=')) {
            return decodeURIComponent(cookie.substring(name.length + 1));
        }
    }
    return null;
}

const removeCookie = name => {
    document.cookie = name + '=; Max-Age=-1; path=/';
}

const getUserInfo = () => {
    const token = getCookie('token');
    if (!token) return {};
    
    try {
        const [header, payload, signature] = token.split('.');
        
        // 한글 안전 디코딩 함수
        const safeDecode = (base64String) => {
            try {
                // 1. Base64 디코딩
                const decoded = atob(base64String);
                
                // 2. 바이트 배열로 변환
                const bytes = new Uint8Array(decoded.length);
                for (let i = 0; i < decoded.length; i++) {
                    bytes[i] = decoded.charCodeAt(i);
                }
                
                // 3. UTF-8로 디코딩
                const textDecoder = new TextDecoder('utf-8');
                const utf8String = textDecoder.decode(bytes);
                
                // 4. JSON 파싱
                return JSON.parse(utf8String);
            } catch (error) {
                // 일반 방법으로 폴백
                return JSON.parse(atob(base64String));
            }
        };
        
        // 한글 안전 디코딩 시도
        let decodedPayload;
        try {
            decodedPayload = safeDecode(payload);
        } catch (error) {
            
            // 폴백: URL 안전 Base64 시도
            try {
                const urlSafePayload = payload.replace(/-/g, '+').replace(/_/g, '/');
                decodedPayload = safeDecode(urlSafePayload);
            } catch (e2) {
                return {};
            }
        }
        
        return decodedPayload;
    } catch (error) {
        return {};
    }
}

export { getCookie, removeCookie, getUserInfo };